import { defineStore } from 'pinia'
import { asyncRoutes } from '@/router/routes'
import { filter } from '@/utils/helper/treeHelper'
import { transformRouteToMenu } from '@/router/helper/menuHelper'
import { RouteLocationNamedRaw, RouteLocationNormalized } from 'vue-router'

export default defineStore('menu', {
  state: () => {
    return {
      frontMenuList: [],
      openKey: []
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'openKey',
        storage: localStorage,
        paths: ['openKey']
      }
    ]
  },
  // 注意：state的成员名称 与 getter成员名称不能相同
  getters: {
    // userInfo: (state) => state.user_info,
    getFrontMenuList(state): any[] {
      return state.frontMenuList
    }
  },
  // actions 支持async/await, actions之间方法互相调用直接用this访问即可
  actions: {
    async buildRoutesAction(): Promise<any[]> {
      let routes = []

      const routeFilter = (route: RouteLocationNormalized) => {
        const { meta } = route
        const { roles } = meta || {}
        if (!roles) return true
        return true
      }

      const routeRmoveIgnoreFilter = (route: RouteLocationNormalized) => {
        const { meta } = route
        const { ignoreRoute } = meta || {}
        return !ignoreRoute
      }

      routes = filter(asyncRoutes, routeFilter)
      routes = routes.filter(routeFilter)
      const menuList = transformRouteToMenu(routes, true)
      console.log(menuList, 'menuList******')
      routes = filter(routes, routeRmoveIgnoreFilter)
      routes = routes.filter(routeRmoveIgnoreFilter)
      menuList.sort((a, b) => {
        return (a.meta?.orderNo || 0) - (b.meta?.orderNo || 0)
      })

      // commit('setFrontMenuList', )
      this.frontMenuList = menuList

      // const routeList = []

      return routes
    }
  }
})
